import { render, staticRenderFns } from "./WaterMeterRecycleBinModal.vue?vue&type=template&id=6f5044e8&scoped=true"
import script from "./WaterMeterRecycleBinModal.vue?vue&type=script&lang=js"
export * from "./WaterMeterRecycleBinModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5044e8",
  null
  
)

export default component.exports